import { Button } from '@goodboydigital/astro';
import { Sprite } from 'pixi.js';

import { Shared } from '../../App';
import LocalisedText from '../LocalisedText';
import { NineSliceButton } from './NineSliceButton';

const defaultOpts = {
    w: 220,
    h: 55,
    scale: 1,
    alpha: 1,
    accessible: false,
    accessibleTitle: 'Reward Button',
    titleText: 'Reward Button',
    buttonText: 'Reward Button',
    nextText: 'Reward Button',
    buttonTextOffset: 0,
    tabIndex: 0,
    buttonAsset: 'button-ninesliced-yellow',
    nineSliceOffset: 50,
};

export type RewardButtonOpts = typeof defaultOpts;

export class RewardButton extends Button
{
    public view: Sprite;

    public buttonText: LocalisedText;
    public titleText: LocalisedText;
    public nextText: LocalisedText;

    protected btn: NineSliceButton;

    constructor(opts: Partial<RewardButtonOpts> = {})
    {
        const o = { ...defaultOpts, ...opts };
        
        const view = new Sprite();

        view.anchor.set(0.5);
        view.scale.set(o.scale);
        view.alpha = o.alpha;

        super(view, o);
        this.view = view;

        const itemHolder = Sprite.from(Shared.assets.getTexture('item-holder-large'));

        itemHolder.anchor.set(0.5);
        view.addChild(itemHolder);

        const mysteryIcon = Sprite.from(Shared.assets.getTexture('card-silhouette'));

        mysteryIcon.anchor.set(0.5);
        view.addChild(mysteryIcon);

        this.titleText = new LocalisedText(o.titleText, {
            fontFamily: 'lubalin',
            fill: 0xFFFFFF,
            stroke: 0x333333,
            strokeThickness: 5,
            lineJoin: 'round',
            align: 'center',
            fontSize: 24,
            maxWidth: o.w,
        });

        this.titleText.y -= 70;
        this.titleText.anchor.set(0.5);
        view.addChild(this.titleText);

        const btnIcon = new Sprite();

        this.buttonText = new LocalisedText(o.buttonText, {
            fontFamily: 'lubalin',
            fill: 0xFFFFFF,
            stroke: 0x333333,
            strokeThickness: 5,
            lineJoin: 'round',
            align: 'center',
            fontSize: 28,
            maxWidth: o.w * 0.7,
        });

        this.buttonText.x += o.buttonTextOffset;
        this.buttonText.anchor.set(0.5);
        btnIcon.addChild(this.buttonText);

        const btn = new NineSliceButton({
            icon: btnIcon,
            nineSliceOffset: o.nineSliceOffset,
            bgAsset: o.buttonAsset,
            w: o.w,
            h: o.h,
        });

        btn.view.y += 60;
        
        view.addChild(btn.view);

        this.btn = btn;

        this.nextText = new LocalisedText(o.nextText, {
            fontFamily: 'lubalin',
            fill: 0xFFFFFF,
            stroke: 0x333333,
            strokeThickness: 4,
            lineJoin: 'round',
            align: 'center',
            fontSize: 18,
            maxWidth: o.w * 0.9,
        });
        view.addChild(this.nextText);
        this.nextText.anchor.set(0.5);
        this.nextText.x = this.btn.view.x;
        this.nextText.y = this.btn.view.y;
    }

    public down(): void
    {
        if (!this.enabled) return;
        this.btn.down();
    }

    public up(): void
    {
        this.btn.up();
    }

    public hover(): void
    {
        if (!this.enabled) return;
        this.btn.hover();
    }

    public modeWaiting(): void
    {
        this.enabled = false;
        this.btn.enabled = false;
        this.btn.view.visible = false;
        this.nextText.visible = true;
    }

    public modeCountdown(): void
    {
        this.enabled = false;
        this.btn.enabled = false;
        this.btn.view.visible = true;
        this.nextText.visible = false;
        this.btn.bg.texture = Shared.assets.getTexture('button-ninesliced-yellow');
    }

    public modeClaim(): void
    {
        this.enabled = true;
        this.btn.enabled = true;
        this.btn.view.visible = true;
        this.nextText.visible = false;
        this.btn.bg.texture = Shared.assets.getTexture('button-ninesliced-magenta');
    }
}
